import dateFormat from 'dateformat'

import AppearanceStep from '../../edit_steps/geobooster_widgets_appearance'
import required from '../../validators/required'
import equalPrimitiveObjects from '../../utils/equalPrimitiveObjects'

export default {
  components: {
    AppearanceStep
  },
  data: () => ({
    steps: {
      appearance: {
        theme: {
          component: 'Radio',
          name: 'theme',
          value: 'light',
          values: [
            {
              text: 'Light mode',
              value: 'light',
              icon: 'fal fa-sun'
            },
            {
              text: 'Dark mode',
              value: 'dark',
              icon: 'fal fa-moon'
            },
            {
              text: 'Custom',
              value: 'custom',
              icon: 'fad fa-sliders-h'
            }
          ],
          label: 'Theme',
          error: false,
          errorText: ''
        },
        font: {
          component: 'Select',
          name: 'font',
          value: 'Arial',
          values: [
            {
              text: 'Arial',
              value: 'Arial'
            }
          ],
          label: 'Font',
          error: false,
          errorText: '',
          disabled: true
        },
        backgroundColor: {
          component: 'ColorPicker',
          name: 'backgroundColor',
          value: '#FFFFFF',
          defaultValue: '#FFFFFF',
          label: 'Background color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        borderColor: {
          component: 'ColorPicker',
          name: 'borderColor',
          value: '#DCDCDC',
          defaultValue: '#DCDCDC',
          label: 'Border color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        customerNameColor: {
          component: 'ColorPicker',
          name: 'customerNameColor',
          value: '#377DFF',
          defaultValue: '#377DFF',
          label: 'Customer color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        textColor: {
          component: 'ColorPicker',
          name: 'textColor',
          value: '#3D454D',
          defaultValue: '#3D454D',
          label: 'Text color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        dateColor: {
          component: 'ColorPicker',
          name: 'textColor',
          value: '#B1B1B1',
          defaultValue: '#B1B1B1',
          label: 'Date color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        dateFormat: {
          component: 'Select',
          name: 'dateFormat',
          value: 'mmm dd, yyyy',
          defaultValue: 'mmm dd, yyyy',
          values: [
            {
              text: 'Oct 27, 2021',
              value: 'mmm dd, yyyy'
            },
            // => "17.02.2023"
            {
              text: '27.10.2021',
              value: 'dd.mm.yyyy'
            },
            // => "02/17/2023"
            {
              text: '10/27/2021',
              value: 'mm/dd/yyyy'
            },
            // => "02.17.2023"
            {
              text: '10.27.2021',
              value: 'mm.dd.yyyy'
            },
            // => "17.02.2023 19:30"
            {
              text: '27.10.2021 19:30',
              value: 'dd.mm.yyyy HH:MM'
            },
            // => "02.17.2023 07:30 PM"
            {
              text: '10.27.2021 07:30 PM',
              value: 'mm.dd.yyyy hh:MM TT'
            }
          ],
          label: 'Date format',
          error: false,
          errorText: ''
        },
        categoryTextColor: {
          component: 'ColorPicker',
          name: 'categoryTextColor',
          value: '#3D454D',
          defaultValue: '#3D454D',
          label: 'Category text color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        categoryBgColor: {
          component: 'ColorPicker',
          name: 'categoryBgColor',
          value: '#EDF0F4',
          defaultValue: '#EDF0F4',
          label: 'Category bg color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        },
        mapMarkerColor: {
          component: 'ColorPicker',
          name: 'mapMarkerColor',
          value: '#377DFF',
          defaultValue: '#377DFF',
          label: 'Map marker color',
          error: false,
          errorText: '',
          validators: {
            required
          }
        }
      }
    },
    darkTheme: {
      backgroundColor: '#2C2C2C',
      borderColor: '#FFFFFF',
      customerNameColor: '#758FDC',
      textColor: '#FFFFFF',
      dateColor: '#C9C5C5',
      mapMarkerColor: '#758FDC',
      categoryTextColor: '#3D454D',
      categoryBgColor: '#EDF0F4'
    },
    lightTheme: {
      backgroundColor: '#FFFFFF',
      borderColor: '#DCDCDC',
      customerNameColor: '#377DFF',
      textColor: '#3D454D',
      dateColor: '#B1B1B1',
      mapMarkerColor: '#377DFF',
      categoryTextColor: '#3D454D',
      categoryBgColor: '#EDF0F4'
    }
  }),
  methods: {
    checkForDefaultValue(key) {
      return this.steps.appearance[key].value === this.steps.appearance[key].defaultValue
    },
    getValueIfNotDefault(key) {
      return this.checkForDefaultValue(key) ? undefined : this.steps.appearance[key].value
    },
    setTheme(theme) {
      const iterablePalette = this[`${theme}Theme`]

      Object.keys(iterablePalette).forEach((key) => {
        const color = iterablePalette[key]
        this.steps.appearance[key].value = color
        this.steps.appearance[key].defaultValue = color
      })
    },
    setDateFormatSelectValues() {
      const dateFormats = this.steps.appearance.dateFormat.values
      const date = new Date()
      dateFormats.forEach((value, index) => {
        dateFormats[index].text = dateFormat(date, value.value)
      })
    }
  },
  computed: {
    palette() {
      return {
        backgroundColor: this.steps.appearance.backgroundColor.value.toUpperCase(),
        borderColor: this.steps.appearance.borderColor.value.toUpperCase(),
        customerNameColor: this.steps.appearance.customerNameColor.value.toUpperCase(),
        textColor: this.steps.appearance.textColor.value.toUpperCase(),
        dateColor: this.steps.appearance.dateColor.value.toUpperCase(),
        mapMarkerColor: this.steps.appearance.mapMarkerColor.value.toUpperCase(),
        categoryTextColor: this.steps.appearance.categoryTextColor.value.toUpperCase(),
        categoryBgColor: this.steps.appearance.categoryBgColor.value.toUpperCase()
      }
    },
    activeTheme() {
      const { lightTheme, darkTheme, palette: activeTheme } = this

      if (equalPrimitiveObjects(lightTheme, activeTheme)) {
        return 'light'
      }

      if (equalPrimitiveObjects(darkTheme, activeTheme)) {
        return 'dark'
      }

      return 'custom'
    }
  },
  watch: {
    'steps.appearance.theme.value': {
      handler(newVal) {
        if (newVal !== 'custom' && newVal !== this.activeTheme) {
          this.setTheme(newVal)
        }
      }
    },
    activeTheme(newVal) {
      this.steps.appearance.theme.value = newVal
    }
  },
  mounted() {
    this.setDateFormatSelectValues()
  }
}
